import * as React from "react";
import { Row } from "reactstrap";
import WorkOrdersChart from "./DashboardCharts/WorkOrders";
import CustomerRequestsChart from "./DashboardCharts/CustomerRequests";

export default class Charts extends React.Component<{ companyId: string }> {
  render() {
    const { companyId } = this.props;

    return (
      <Row
        style={{ marginTop: "30px", marginBottom: "30px", minHeight: "300px" }}
      >
        <WorkOrdersChart companyId={companyId} />
        <CustomerRequestsChart companyId={companyId} />
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/Charts.tsx